<template>
  <v-card
    flat
    class="pa-3 mt-2"
  >
    <v-card-text class="d-flex">
      <v-avatar
        rounded
        size="120"
        class="me-6"
      >
        <v-img
          :src="logoEmpresa"
        ></v-img>
      </v-avatar>

      <!-- upload photo -->
      <div class="d-flex flex-column align-center justify-center">
        <div class="d-flex flex-wrap align-center justify-center">
          <v-btn
            v-if="acessoPut"
            color="primary"
            class="me-sm-3 me-none mt-3 p-0"
            @click="inputLogoEmpresaRef.click()"
          >
            <span class="d-sm-inline d-none p-0 m-0">{{ uploadOrUpdateLogo }} da empresa</span>
            <span class="d-sm-none d-block p-0 m-0">{{ uploadOrUpdateLogo }}</span>
          </v-btn>
          <v-btn
            v-else
            color="primary"
            class="me-sm-3 me-none mt-3 p-0"
            disabled
          >
            <span class="d-sm-inline d-none p-0 m-0">{{ uploadOrUpdateLogo }} da empresa</span>
            <span class="d-sm-none d-block p-0 m-0">{{ uploadOrUpdateLogo }}</span>
          </v-btn>

          <input
            ref="inputLogoEmpresaRef"
            type="file"
            accept=".png, .jpg, .jpeg"
            :hidden="true"
            @change="parseFotoUpload"
            @click="resetInput"
          />

          <v-btn
            v-if="accountDataLocale.fotoDataUrl"
            color="error"
            outlined
            class="mt-3"
            @click="descartarFotoUpload"
          >
            Descartar
          </v-btn>
        </div>

        <p class="d-sm-block d-none text-sm text-center mt-5">
          <span class="d-md-inline d-none">Formato PNG, JPG ou JPEG.</span> Tamanho máximo de 1MB.
        </p>
      </div>
    </v-card-text>

    <p class="d-sm-none d-block text-sm text-center mt-4 mb-7">
      Formato PNG. Tamanho máximo de 1MB.
    </p>

    <v-card-text>
      <v-form class="multi-col-validation mt-6">
        <v-row>
          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="accountDataLocale.cpfCnpj"
              label="CNPJ"
              dense
              outlined
              :rules="[validators.required, validators.isCnpjValido]"
            ></v-text-field>
          </v-col>

          <v-col
            md="8"
            cols="12"
          >
            <v-text-field
              v-model="accountDataLocale.sobrenome"
              label="Nome da empresa"
              dense
              outlined
              :rules="[validators.required]"
            ></v-text-field>
          </v-col>

          <v-col
            md="4"
            cols="12"
          >
            <v-text-field
              v-model="accountDataLocale.nome"
              label="Razão Social"
              dense
              outlined
              :rules="[validators.required]"
            ></v-text-field>
          </v-col>

          <v-col
            md="8"
            cols="12"
          >
            <v-text-field
              v-model="accountDataLocale.nome"
              label="Nome do responsável"
              dense
              outlined
              :rules="[validators.required]"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-btn
              v-if="acessoPut"
              color="primary"
              class="me-3 mt-4"
              @click="updateEmpresa"
            >
              <v-progress-circular
                v-if="loading"
                class="mx-3"
                indeterminate
                color="secundary"
              />

              <span v-else>Salvar alterações</span>
            </v-btn>
            <v-btn
              v-else
              color="primary"
              class="me-3 mt-4"
              disabled
            >
              Salvar alterações
            </v-btn>
            <v-btn
              color="secondary"
              outlined
              class="mt-4"
              type="reset"
              @click.prevent="resetForm"
            >
              Cancelar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import Vue from 'vue'
import { ref, onMounted, computed } from '@vue/composition-api'
import { mdiAlertOutline, mdiCloudUploadOutline } from '@mdi/js'
import { required } from '@core/utils/validation'
import { storeToRefs } from 'pinia'
import { isCnpjValido } from '@/utils/validation'
import useUserStore from '@/store/user'
import ColaboradorService from '@/services/modules/ColaboradorService'

export default {
  props: {
    accountData: {
      type: Object,
      default: () => {},
    },
    acessoPut: {
      type: Boolean,
      default: true,
    },
  },

  setup(props) {
    const userStore = useUserStore()
    const { setAvatar } = userStore
    const { avatar } = storeToRefs(userStore)

    const inputLogoEmpresaRef = ref(null)
    const logoEmpresa = ref(require('@/assets/images/avatars/avatar_user.png'))
    const antigoLogoEmpresa = ref(logoEmpresa.value)

    const accountDataLocale = ref(JSON.parse(JSON.stringify(props.accountData)))
    const uploadOrUpdateLogo = computed(() => (!accountDataLocale.value.fotoId ? 'Upload do logo' : 'Atualizar logo'))

    const resetForm = () => {
      accountDataLocale.value = props.accountData
    }

    onMounted(() => {
      if (avatar.value) {
        logoEmpresa.value = avatar.value
        antigoLogoEmpresa.value = logoEmpresa.value
      }
    })

    const descartarFotoUpload = () => {
      accountDataLocale.value.fotoDataUrl = undefined
      logoEmpresa.value = antigoLogoEmpresa.value
    }
    const resetInput = () => {
      inputLogoEmpresaRef.value.value = null
    }

    const parseFotoUpload = e => {
      const file = e.target.files[0]
      const reader = new FileReader()
      reader.onloadend = () => {
        const dataUrl = reader.result
        const tamanhoImagemEmMB = new Blob([dataUrl]).size / 1_048_576

        if (tamanhoImagemEmMB > 1) {
          Vue.$toast.warning('A imagem não pode ter mais de 1MB.', { timeout: false })
        } else {
          accountDataLocale.value.fotoDataUrl = dataUrl
          logoEmpresa.value = dataUrl
        }
      }
      reader.readAsDataURL(file)
    }

    const loading = ref(false)
    const updateEmpresa = () => {
      loading.value = true
      accountDataLocale.value.id = null

      ColaboradorService
        .update(accountDataLocale.value)
        .then(() => {
          setTimeout(() => {
            loading.value = false
          }, 1000)

          setAvatar(accountDataLocale.value.fotoDataUrl)

          accountDataLocale.value.fotoDataUrl = null
        })
    }

    return {
      inputLogoEmpresaRef,
      logoEmpresa,
      accountDataLocale,
      uploadOrUpdateLogo,
      resetForm,
      descartarFotoUpload,
      resetInput,
      parseFotoUpload,
      loading,
      updateEmpresa,
      icons: {
        mdiAlertOutline,
        mdiCloudUploadOutline,
      },
      validators: {
        required,
        isCnpjValido,
      },
    }
  },
}
</script>
